import type { AppProps } from 'next/app'
import { DefaultSeo } from 'next-seo'
import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material'
import theme from '../lib/Theme'
import '@fontsource/inter/variable.css'

// TODO: Sentry init + add Sentry to package.json
/**
 * This component represents the root of the application. It's rendered on
 * both the server and the client, so any client-side logic should live
 * within this component or its children.
 * For more info, see {@link https://stackoverflow.com/questions/51040669/next-js-use-of-app-js-and-document-js}.
 */
function App({ Component, pageProps }: AppProps) {
  return (
    <>
      <DefaultSeo
        title="Hypotenuse AI"
        description="Get an entire blog post written in minutes with AI."
        additionalLinkTags={[{ rel: 'icon', href: '/favicon.ico' }]}
        dangerouslySetAllPagesToNoIndex // Prevent indexing of all pages in this app
      />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles
          styles={{
            // Default styles applied globally
            body: {
              fontFamily:
                '"InterVariable", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
              backgroundColor: theme.palette.background.default
            },
            html: {
              fontSize: '0.875rem'
            }
          }}
        />
        <Component {...pageProps} />
      </ThemeProvider>
    </>
  )
}

export default App
